import {
  delRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../connection/network";
const authApi = {
  check: "auth/check",
  register: "/auth/register",
  updateProfile: "user/profile",
  contact: "user/contacts",
  resetPassword: {
    request: "auth/reset-password/request",
    verify: "auth/reset-password/verify",
    reset: "auth/reset-password/reset",
  },
  updatePriveBot: "user/private-bot",
  subsribe: "auth/subscribe",
  companyRegister: "company/register",
  verifyEmail: "auth/verify-email",
};

export const updatePrivateBotService = async ({ cb, data: body }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await putRequest({
      endPoint: authApi.updatePriveBot,
      token,
      body,
    });
    if (cb) cb(null);
    return { data };
  } catch (e) {
    const { error } = e?.response?.data;
    if (cb) cb(error);
    return { error };
  }
};

export const sendPasswordRequestService = async ({ body, cb }) => {
  try {
    let {
      data: { data },
    } = await putRequest({
      body: { ...body },
      endPoint: authApi.resetPassword.request,
    });

    cb && cb(null);
    return { data };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    cb && cb(sError);
    return { error: sError };
  }
};

export const verifyPasswordResetService = async ({ body, cb }) => {
  try {
    let {
      data: { data },
    } = await putRequest({
      body: { ...body },
      endPoint: authApi.resetPassword.verify,
    });

    cb && cb(null);
    return { data };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    cb && cb(sError);
    return { error: sError };
  }
};

export const resetPasswordService = async ({ body, cb }) => {
  try {
    let {
      data: { data },
    } = await putRequest({
      body: { ...body },
      endPoint: authApi.resetPassword.reset,
    });

    cb && cb(null);
    return { data };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    cb && cb(sError);
    return { error: sError };
  }
};

export const checkExistsService = async ({ mobile, email, username }) => {
  try {
    await getRequest({
      query: {
        mobile,
        email,
        username,
      },
      endPoint: authApi.check,
    });
    return { success: true };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { success: false, error: sError };
  }
};

export const registerService = async ({ data: sendData }) => {
  try {
    const sendFormData = new FormData();
    for (const [key, value] of Object.entries(sendData)) {
      value && sendFormData.append(key, value);
    }
    let {
      data: { data, message },
    } = await postRequest({ body: sendFormData, endPoint: authApi.register });

    return { data };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};

export const updateProfileService = async ({ body, cb }) => {
  const token = localStorage.getItem("token");
  try {
    let {
      data: { data },
    } = await putRequest({ body, endPoint: authApi.updateProfile, token });

    cb && cb(null);
    return { data };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    cb && cb(sError);
    return { error: sError };
  }
};

export const deleteUserContactSerivce = async ({ contactIds }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data, message },
    } = await delRequest({
      endPoint: authApi.contact,
      token,
      query: {
        contactIds,
      },
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};

export const subscribeDeviceTokenService = async (deviceToken) => {
  if (deviceToken) {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await getRequest({
          query: { deviceToken },
          endPoint: authApi.subsribe,
          token,
        });
      } catch (error) {
        console.error(error);
      }
    }
  }
};

//////////////////////////Company

export const registerCompanyService = async ({ data: sendData }) => {
  try {
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: authApi.companyRegister,
    });

    return { data };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};

export const verifyEmailService = async ({ sendData }) => {
  try {
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: authApi.verifyEmail,
    });

    return { data, message };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};
